<template>
    <div class="info-section" id="services">
      <div class="text-content">
        <h1 class="main-title">Prexange : retour du client centrique !</h1>
        <p class="description">
          Prexange permet aux demandeurs de crédit, accompagnés de leur courtier, d’optimiser leurs chances de trouver le meilleur financement, dans un délai très court !
        </p>
        <p class="details">
          Accès à un espace privé sécurisé et à un coffre fort digital pour transférer les documents personnels.
        </p>
      </div>
      <div class="button-group">
        <button class="btn signInBtn ">
          <a href="https://us17.list-manage.com/contact-form?u=12eb10c034208fa73e5a394c1&form_id=3349a43f091cf8acd4ccbbef24d933e5" target="_blank" class="text" style="text-decoration: none;color: white;">
          <Icon class="icon" icon="fluent:arrow-right-24-regular" height="20" />
          <span>Démarrer une collaboration</span>
          </a>
        </button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "InformationSection",
  };
  </script>
  
  <style lang="scss">
  @import './firstService.scss'
  
  </style>
  